import axios from 'axios'

const API_PATH = 'api/v2/admins/customers/refunds/vouchers'

const CustomerRefundVouchersApiV2 = {
  /**
   * Get list of Customer Refund with Voucher Code Method
   * Invoke `GET api/v2/admins/customers/refunds/vouchers
   * @param {object} tableState - ReactTable final state
   */
  get: async ( params ) => {
    const path = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Get detail of Customer Refunds with Voucher by id
   * Invoke `GET api/v2/admins/customers/refunds/vouchers/:order_id
   * @param {string} orderId - id of customer order
   */
  show: async (orderId) => {
    const path = `${API_PATH}/${orderId}`

    const response = axios.get(path, {})
    return response
  },

  /**
   * Generate new voucher rule
   * update Customer Refunds with Voucher code by orderId
   * Invoke `POST api/v2/admins/customers/refunds/vouchers/generate
   * @param {string} orderId - id of customer order
   */
  generateVoucher: ({ orderId, productRules }) => {
    const path = `${API_PATH}/generate`

    const payload = {
      order_id      : orderId,
      product_rules : productRules
    }

    const response = axios.post(path, payload)
    return response
  }
}

export default CustomerRefundVouchersApiV2
